export default __webpack_public_path__ + "static/media/img19.ac60fb3d.jpg";